var exports = {
  "k": "x127c5a35--4e65f5--container",
};

module.exports = exports;
